import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_GET_LISTING_BY_ID,
} from 'api/actionTypes';

import makeInitialState from 'client/makeInitialState';

import { full as fullListingFieldgroup } from 'server/models/Listing/fieldgroups';
import {
  actionAddListingsToStateManager,
} from 'client/helpers/listingsStateManager';

export default async function getById({ state, apiClient }, listingId) {
  let reload;
  if (!listingId) {
    return;
  }
  if (typeof listingId === 'object') {
    reload = listingId.reload;
    listingId = listingId.listingId;
  }
  listingId = parseInt(listingId, 10);
  typeCheck('listingId::Number', listingId);

  const currentListingId = state.get(['listing', 'id']);

  if (!reload) {
    // Listing data already exists.
    if (currentListingId === listingId) {
      const listing = state.get(['listing']);
      return listing;
    }

    // Search listing on properties array.
    if (state.exists(['listings', 'records', { id: listingId }])) {
      const listing = state.get(['listings', 'records', { id: listingId }]);
      state.set(['listing'], listing);
      state.commit();
      return listing;
    }

    // Search listing on listingsDataManager
    if (state.exists(['listingsDataManager', 'listings', { id: listingId }])) {
      const listing = state.get(['listingsDataManager', 'listings', { id: listingId }]);
      state.set(['listing'], listing);
      state.commit();
      return listing;
    }

    if (currentListingId) {
      state.set(['listing'], makeInitialState().listing);
    }
  }

  let listing;

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_BY_ID,
    state: state,
    payload: {
      listingId: listingId,
      fieldgroup: fullListingFieldgroup,
    },
    onSuccess(loadedListing) {
      if (loadedListing) {
        listing = loadedListing;
        state.set(['listing'], listing);

        actionAddListingsToStateManager({ state }, { listings: [listing] });
      }
    },
  });

  return listing;
}
